import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 8v8l5-4-5-4zm11-5H3v18h18V3zm-2 16H5V5h14v14z"
}), 'SlideshowSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/SlideshowSharp.js
// module id = 6276
// module chunks = 2